import React from 'react';
import styles from "../../styles/components/framworkStepper.module.scss";
import Icons from "../../public/assets/svg/index";
import endpoints from '../../utility/endpoints'

export default function frameworkStepper(props) {


//     console.log(props, "stepper")
//    let detailAr = props.data[0].field_details.split("<p>")
//    for ( let i in detailAr) {
       
//        detailAr[i] = "<p styles.dataLine>" + detailAr[i];
//    }
//    const aa = detailAr.shift()
//    const aaa = detailAr.join()
//    console.log(aaa)



    return (
      <div className={styles.stepperContainer}>
        
        {props.data.map((item, index) => 
             <div
               className={`${styles.stepperCardWrapper} ${
                 index == 0
                   ? styles.discover
                   : index == 1
                   ? styles.designProcess
                   : index == 2
                   ? styles.deploySustain
                   : index == 3
                   ? styles.developSolution
                   : null
               }`}
               key={index}
             >
               <div
                 className={`${styles.head} ${
                   index == 0
                     ? styles.discover
                     : index == 1
                     ? styles.designProcess
                     : index == 2
                     ? styles.deploySustain
                     : index == 3
                     ? styles.developSolution
                     : null
                 }`}
               >
                 <div
                   className={`${styles.icon} ${
                     index == 0
                       ? styles.discover
                       : index == 1
                       ? styles.designProcess
                       : index == 2
                       ? styles.deploySustain
                       : index == 3
                       ? styles.developSolution
                       : null
                   }`}
                 >
                   <img
                     src={`${endpoints.drupalIp}${item.field_background_image[0].file_url}`}
                   ></img>
                 </div>
                 <div
                   className={`${styles.title} ${
                     index == 0
                       ? styles.discover
                       : index == 1
                       ? styles.designProcess
                       : index == 2
                       ? styles.deploySustain
                       : index == 3
                       ? styles.developSolution
                       : null
                   }`}
                 >
                   <p>{item.field_title}</p>
                 </div>
               </div>
               <div
                 className={`${styles.body} ${
                   index == 0
                     ? styles.discover
                     : index == 1
                     ? styles.designProcess
                     : index == 2
                     ? styles.deploySustain
                     : index == 3
                     ? styles.developSolution
                     : null
                 }`}
                 dangerouslySetInnerHTML={{
                   __html: item.field_details,
                 }}
               >
               </div>
             </div>
        )}

        {/* <div className={`${styles.stepperCardWrapper} ${styles.designProcess}`}>
          <div className={`${styles.head} ${styles.designProcess}`}>
            <div className={`${styles.icon} ${styles.designProcess}`}>
              <p>icn</p>
            </div>
            <div className={`${styles.title} ${styles.designProcess}`}>
              <p>design pattern</p>
            </div>
          </div>
          <div className={`${styles.body} ${styles.designProcess}`}>
            <p className={styles.dataLine}>Proceed Expert Led</p>
            <p className={styles.dataLine}>
              Metrics, Analytics &amp; Benchmarking
            </p>
            <p className={styles.dataLine}>Indentify NVA Activites (LEAN)</p>
            <p className={styles.dataLine}>Process Mining</p>
            <p className={styles.dataLine}>Define Automation Opportunity</p>
          </div>
        </div>

        <div className={`${styles.stepperCardWrapper} ${styles.deploySustain}`}>
          <div className={`${styles.head} ${styles.deploySustain}`}>
            <div className={`${styles.icon} ${styles.deploySustain}`}>
              <p>icn</p>
            </div>
            <div className={`${styles.title} ${styles.deploySustain}`}>
              <p>design pattern</p>
            </div>
          </div>
          <div className={`${styles.body} ${styles.deploySustain}`}>
            <p className={styles.dataLine}>Proceed Expert Led</p>
            <p className={styles.dataLine}>
              Metrics, Analytics &amp; Benchmarking
            </p>
            <p className={styles.dataLine}>Indentify NVA Activites (LEAN)</p>
            <p className={styles.dataLine}>Process Mining</p>
            <p className={styles.dataLine}>Define Automation Opportunity</p>
          </div>
        </div>

        <div
          className={`${styles.stepperCardWrapper} ${styles.developSolution}`}
        >
          <div className={`${styles.head} ${styles.developSolution}`}>
            <div className={`${styles.icon} ${styles.developSolution}`}>
              <p>icn</p>
            </div>
            <div className={`${styles.title} ${styles.developSolution}`}>
              <p>design pattern</p>
            </div>
          </div>
          <div className={`${styles.body} ${styles.developSolution}`}>
            <p className={styles.dataLine}>Proceed Expert Led</p>
            <p className={styles.dataLine}>
              Metrics, Analytics &amp; Benchmarking
            </p>
            <p className={styles.dataLine}>Indentify NVA Activites (LEAN)</p>
            <p className={styles.dataLine}>Process Mining</p>
            <p className={styles.dataLine}>Define Automation Opportunity</p>
          </div>
        </div> */}
      </div>
    );
}
